import {
  Transition as MantineTransition,
  TransitionProps,
} from '@mantine/core';

export type ITransitionProps = TransitionProps;

/** @registry Design-layer pass-through over Mantine Transition; import this instead of @mantine/core Transition outside src/design. */
export const Transition = MantineTransition;
